module.exports = __webpack_public_path__ + "static/media/uj_dokfeltoltes3.7f8dcb96.jpg";